const envUrl = process.env.REACT_APP_API_URL;
const hostname = window.location.hostname;
const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1";

// Logic: Use env var if set, UNLESS it forces localhost while we are on a real IP
let finalUrl = envUrl;

if (hostname === "app.vochica.com") {
    // Production domain should use Nginx proxy
    finalUrl = "https://app.vochica.com/api";
} else if (!finalUrl || (finalUrl.includes("localhost") && !isLocalhost)) {
    // If the hostname is localhost, use the same origin to avoid Mixed Content/CORS
    finalUrl = isLocalhost
        ? `${window.location.protocol}//localhost${window.location.port ? ':' + window.location.port : ''}/api`
        : `http://${hostname}:8000`;
}

// Override logic to ensure local dev server NEVER gets stuck on production endpoints
if (window.location.port === "3000" && isLocalhost) {
    // If running locally on PC, also drop the /api
    finalUrl = `http://localhost:8000`;
}

export const API_URL = finalUrl;
